import Repository from "./Repository";
import _ from "lodash";

const getPath = (path) => {
    return `${path}`;
}
class DocumentRepository extends Repository {

    getDocumentList = async (param) => {
        try {
            const courseId = param?.course_id ?? param;
            const parentId = param?.parent_id;
            const searchValue = param?.search || "";
            let path = `documents/course/list/${courseId}`;
            if (parentId != null && parentId !== 0) {
                path = `documents/course/list/${courseId}/${parentId}`;
            }
            if (searchValue) {
                path = `${path}?search=${encodeURIComponent(searchValue)}`;
            }

            const data = await this.getData(path);
            return _.get(data, `data`);
        } catch (error) {
            return { error }
        }
    }
    addDocument = async (param) => {
        try {
            const path = param?.path || `documents/course/upload`;
            const fd = param?.fd || param;
            const data = await this.uploadForm(path, fd);
            return _.get(data, `data`);
        } catch (error) {
            return { error }
        }
    }

    updateDocument = async (param) => {
        try {
            const documentId = param?.document_id || param?.id;
            const path = documentId
                ? `documents/course/update/${documentId}`
                : `documents/course/update`;
            const fd = param?.fd || param;
            const data = await this.uploadForm(path, fd);
            return _.get(data, `data`);
        } catch (error) {
            return { error }
        }
    }

    deleteDocument = async (param) => {
        try {
            const data = await this.deleteData(`documents/delete/${param}`);
            return _.get(data, `data`);
        } catch (error) {
            return { error }
        }
    }
    updateDocumentStatus = async (param) => {
        try {
            const data = await this.postData(`documents/status/change`, param);
            return _.get(data, `data`);
        } catch (error) {
            return { error }
        }
    }

    createFolder = async (param) => {
        try {
            let courseId;
            let body;

            // Check if param is FormData or a plain object
            if (param instanceof FormData) {
                courseId = param.get("course_id");
                const documentId = param.get("current_document_id");
                if (documentId) {
                    param.append("document_id", documentId);
                }
                body = param;
            } else {
            courseId = param?.course_id;
            const documentId = param?.current_document_id;
             body = { ...param };
            if (documentId) body.document_id = documentId;
            }

            const path = courseId
                ? `documents/course/create-folder/${courseId}`
                : `documents/course/create-folder`;

            const data = await this.postData(path, body);
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    getRecentViewedList = async (courseId) => {
        try {
            if (!courseId) {
                return [];
            }
            const data = await this.getData(`documents/course/recent-viewed/${courseId}`);
            const documents = _.get(data, "data.data.documents", []);
            return Array.isArray(documents) ? documents : [];
        } catch (error) {
            return { error };
        }
    };

    getFileUrl = async (documentId) => {
        try {
            if (!documentId) {
                return null;
            }

            const data = await this.getData(
                `documents/file-url/${documentId}`
            );
            return _.get(data, "data.data", null);
        } catch (error) {
            return { error };
        }
    };

    checkDocumentAssociation = async (documentId) => {
        try {
            const data = await this.getData(`documents/course/check-association/${documentId}`);
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    }

    savePageNote = async (param) => {
        try {
        const payload = {
            document_id: param?.document_id,
            page_no: param?.page_no,
            note: param?.note,
            ...(param?.is_deleted ? { is_deleted: true } : {}),
        };
        const data = await this.postData(`student/document-note/save`, payload);
        return _.get(data, `data`, data);
        } catch (error) {
        return { error };
        }
    };

    getPageNote = async (param) => {
        try {
        const documentId = param?.document_id;
        const pageNumber = param?.page_no;
        const data = await this.getData(
            `student/document-note/get/${documentId}/${pageNumber}`
        );
        return _.get(data, `data.data`, _.get(data, `data`));
        } catch (error) {
        return { error };
        }
    };
}

export default new DocumentRepository("document");